import { moduleName, moduleObject } from './store-module'

const tokenName = 'auth_token'
const refreshInterval = 15 // in minutes

export default {
  install: function(Vue, options = {}) {
    let store = options.store
    let http = Vue.http

    if (store === undefined || store === null) {
      throw new Error("You have to pass the Vuex store to the 'options' object.")
    }

    if (http === undefined || http === null) {
      throw new Error("You have to set up 'VueResource' plugin before this plugin.")
    }

    // register Vuex module
    store.registerModule(moduleName, moduleObject)

    // check if the plugin was correctly initialized
    if (store.state.hasOwnProperty(moduleName) === false) {
      throw new Error('ORES auth module is not correctly initialized.')
    }

    let existingToken = window.localStorage.getItem(tokenName)
    if (existingToken !== null && existingToken !== 'undefined') {
      // register token to http and store
      processTokenForAnyModules(http, store, existingToken)
    }

    // automatically refresh the token
    setInterval(function() {
      let token = window.localStorage.getItem(tokenName)
      if (token === null) {
        console.warn('Cannot find a token to refresh...')
        return
      }

      http.get('login/refresh').then(
        response => {
          processTokenForAnyModules(http, store, response.body)
        },
        response => {
          console.error(response)
          deleteToken(store)
        }
      )
    }, refreshInterval * 1000 * 60)

    // Vue.mixin({
    // })

    // inject plugin functions
    Vue.prototype.$auth = {
      loginForIndex(captchaToken, payload) {
        http.headers.common['g-recaptcha-response'] = captchaToken
        return http
          .post('login/meter-reading', payload)
          .then(response => {
            let token = response.body
            processTokenForMeterReading(http, store, token)
            return Promise.resolve(response)
          })
          .catch(error => Promise.reject(error))
      },
      loginForUnsubscribe(captchaToken, payload) {
        http.headers.common['g-recaptcha-response'] = captchaToken
        return http
          .post('login/unsubscribe', payload)
          .then(response => {
            let token = response.body
            processUnsubscribe(http, store, token)
            return Promise.resolve(response)
          })
          .catch(error => Promise.reject(error))
      },
      loginForConsumption(captchaToken, payload) {
        http.headers.common['g-recaptcha-response'] = captchaToken
        return http
          .post('login/consumption', payload)
          .then(response => {
            let token = response.body
            processTokenForConsumption(http, store, token)
            return Promise.resolve(response)
          })
          .catch(error => Promise.reject(error))
      },
      loginForAppointment(captchaToken, payload) {
        http.headers.common['g-recaptcha-response'] = captchaToken
        return http
          .post('login/appointment', payload)
          .then(response => {
            let token = response.body
            processTokenForAppointment(http, store, token)
            return Promise.resolve(response)
          })
          .catch(error => Promise.reject(error))
      },
      loginForMonthOfStatement(captchaToken, payload) {
        http.headers.common['g-recaptcha-response'] = captchaToken
        return http
          .post('login/month-of-statement', payload)
          .then(response => {
            let token = response.body
            processTokenForMonthOfStatement(http, store, token)
            return Promise.resolve(response)
          })
          .catch(error => Promise.reject(error))
      },
      logout() {
        deleteToken(store)
      },
      isAmr() {
        return getToken().amr_meter
      },
      isMmr() {
        return getToken().mmr_meter
      },
      isYmr() {
        return getToken().ymr_meter
      }
    }
  }
}

function getToken() {
  let token = window.localStorage.getItem(tokenName)
  if (token !== undefined || token != null) {
    throw new Error('ORES auth module doesn t find any token.')
  }

  return decodeTokenPayload(token)
}

function processToken(http, store, mutation, token) {
  // persist token
  window.localStorage.setItem(tokenName, token)
  // add the token to any http request
  http.headers.common['Authorization'] = token
  // set the store states
  store.commit(mutation, token)
}

function processTokenForMeterReading(http, store, token) {
  processToken(http, store, 'auth/authenticateMeterReading', token)
}

function processTokenForConsumption(http, store, token) {
  processToken(http, store, 'auth/authenticateConsumption', token)
}

function processTokenForAppointment(http, store, token) {
  processToken(http, store, 'auth/authenticateAppointment', token)
}

function processUnsubscribe(http, store, token) {
  processToken(http, store, 'auth/authenticateUnsubscribe', token)
}

function processTokenForMonthOfStatement(http, store, token) {
  processToken(http, store, 'auth/authenticateMonthOfStatement', token)
}

function processTokenForAnyModules(http, store, token) {
  const source = decodeTokenPayload(token).login_source
  processToken(http, store, 'auth/authenticate' + source, token)
}

function deleteToken(vuexStore) {
  vuexStore.commit('auth/disconnect')
  localStorage.removeItem(tokenName)
}

function decodeTokenPayload(token) {
  return JSON.parse(atob(token.split('.')[1]))
}
